'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ColorArea", {
    enumerable: true,
    get: function() {
        return ColorArea;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useColorArea = require("./useColorArea");
const _renderColorArea = require("./renderColorArea");
const _useColorAreaStylesstyles = require("./useColorAreaStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const ColorArea = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useColorArea.useColorArea_unstable)(props, ref);
    (0, _useColorAreaStylesstyles.useColorAreaStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useColorAreaStyles_unstable')(state);
    return (0, _renderColorArea.renderColorArea_unstable)(state);
});
ColorArea.displayName = 'ColorArea';
